import { createStructuredSelector } from 'reselect'

import {
  ACQUISITION_DETAIL_LIST,
  ACQUISITION_DETAIL_LIST_SUCCESS,
  ACQUISITION_DETAIL_LIST_ERROR,
  ACQUISITION_DETAIL_SEARCH_ARTICLE_GROUP_LIST,
  ACQUISITION_DETAIL_SEARCH_ARTICLE_GROUP_LIST_SUCCESS,
  ACQUISITION_DETAIL_SEARCH_ARTICLE_GROUP_LIST_ERROR,
  ACQUISITION_DETAIL_SEARCH_SET,
  ACQUISITION_DETAIL_PAGE_SET,
  ACQUISITION_DETAIL_VIEW_MODAL_SET,
  ACQUISITION_DETAIL_VIEW_TAB_SET,
  ACQUISITION_DETAIL_SEARCH_CHANGE,
  ACQUISITION_DETAIL_HEADER,
  ACQUISITION_DETAIL_SEARCH_PROJECT_LIST,
  ACQUISITION_DETAIL_SEARCH_PROJECT_LIST_SUCCESS,
  ACQUISITION_DETAIL_SEARCH_PROJECT_LIST_ERROR,
  ACQUISITION_DETAIL_SEARCH_ACQUISITION_LIST,
  ACQUISITION_DETAIL_SEARCH_ACQUISITION_LIST_SUCCESS,
  ACQUISITION_DETAIL_SEARCH_ACQUISITION_LIST_ERROR,
  ACQUISITION_DETAIL_SEARCH_YEAR_LIST,
  ACQUISITION_DETAIL_SEARCH_YEAR_LIST_SUCCESS,
  ACQUISITION_DETAIL_SEARCH_YEAR_LIST_ERROR,
  ACQUISITION_DETAIL_SEARCH_ACQUISITION_DETAIL_TYPE_LIST,
  ACQUISITION_DETAIL_SEARCH_ACQUISITION_DETAIL_TYPE_LIST_SUCCESS,
  ACQUISITION_DETAIL_SEARCH_ACQUISITION_DETAIL_TYPE_LIST_ERROR,
  ACQUISITION_DETAIL_DETAIL,
  ACQUISITION_DETAIL_DETAIL_SUCCESS,
  ACQUISITION_DETAIL_DETAIL_ERROR,
  ACQUISITION_DETAIL_SEARCH_DEMAND_LIST,
  ACQUISITION_DETAIL_SEARCH_DEMAND_LIST_SUCCESS,
  ACQUISITION_DETAIL_SEARCH_DEMAND_LIST_ERROR,
} from '../actions';

export const NAME = 'acquisitionDetail';

export const AcquisitionDetailList = (page, num_page, orderBy, filters, stateFilter) => ({
  type: ACQUISITION_DETAIL_LIST,
  payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter }
});

export const AcquisitionDetailListSuccess = (data) => ({
  type: ACQUISITION_DETAIL_LIST_SUCCESS,
  payload: data
});

export const AcquisitionDetailListError = (error) => ({
  type: ACQUISITION_DETAIL_LIST_ERROR,
  payload: error
});

export const AcquisitionDetailSearchArticleGroupList = () => ({
  type: ACQUISITION_DETAIL_SEARCH_ARTICLE_GROUP_LIST
});

export const AcquisitionDetailSearchArticleGroupListSuccess = (data) => ({
  type: ACQUISITION_DETAIL_SEARCH_ARTICLE_GROUP_LIST_SUCCESS,
  payload: data
});

export const AcquisitionDetailSearchArticleGroupListError = (error) => ({
  type: ACQUISITION_DETAIL_SEARCH_ARTICLE_GROUP_LIST_ERROR,
  payload: error
});

export const AcquisitionDetailSearchSet = (data) => ({
  type: ACQUISITION_DETAIL_SEARCH_SET,
  payload: data
});

export const AcquisitionDetailPageSet = (data) => ({
  type: ACQUISITION_DETAIL_PAGE_SET,
  payload: data
});

export const AcquisitionDetailViewModalSet = (data) => ({
  type: ACQUISITION_DETAIL_VIEW_MODAL_SET,
  payload: data
});


export const AcquisitionDetailHeader = (data) => ({
  type: ACQUISITION_DETAIL_HEADER,
  payload: data
});

export const AcquisitionDetailViewTabSet = (data) => ({
  type: ACQUISITION_DETAIL_VIEW_TAB_SET,
  payload: data
});


export const AcquisitionDetailSearchChangeSet = (data) => ({
  type: ACQUISITION_DETAIL_SEARCH_CHANGE,
  payload: data
});

export const AcquisitionDetailSearchProjectList = () => ({
  type: ACQUISITION_DETAIL_SEARCH_PROJECT_LIST
});

export const AcquisitionDetailSearchProjectListSuccess = (message) => ({
  type: ACQUISITION_DETAIL_SEARCH_PROJECT_LIST_SUCCESS,
  payload: message
});

export const AcquisitionDetailSearchProjectListError = (error) => ({
  type: ACQUISITION_DETAIL_SEARCH_PROJECT_LIST_ERROR,
  payload: error
}); 

export const AcquisitionDetailSearchAcquisitionList = () => ({
  type: ACQUISITION_DETAIL_SEARCH_ACQUISITION_LIST
});

export const AcquisitionDetailSearchAcquisitionListSuccess = (message) => ({
  type: ACQUISITION_DETAIL_SEARCH_ACQUISITION_LIST_SUCCESS,
  payload: message
});

export const AcquisitionDetailSearchAcquisitionListError = (error) => ({
  type: ACQUISITION_DETAIL_SEARCH_ACQUISITION_LIST_ERROR,
  payload: error
}); 

export const AcquisitionDetailSearchYearList = () => ({
  type: ACQUISITION_DETAIL_SEARCH_YEAR_LIST
});

export const AcquisitionDetailSearchYearListSuccess = (message) => ({
  type: ACQUISITION_DETAIL_SEARCH_YEAR_LIST_SUCCESS,
  payload: message
});

export const AcquisitionDetailSearchYearListError = (error) => ({
  type: ACQUISITION_DETAIL_SEARCH_YEAR_LIST_ERROR,
  payload: error
}); 


export const AcquisitionDetailSearchAcquisitionDetailTypeList = () => ({
  type: ACQUISITION_DETAIL_SEARCH_ACQUISITION_DETAIL_TYPE_LIST
});

export const AcquisitionDetailSearchAcquisitionDetailTypeListSuccess = (message) => ({
  type: ACQUISITION_DETAIL_SEARCH_ACQUISITION_DETAIL_TYPE_LIST_SUCCESS,
  payload: message
});

export const AcquisitionDetailSearchAcquisitionDetailTypeListError = (error) => ({
  type: ACQUISITION_DETAIL_SEARCH_ACQUISITION_DETAIL_TYPE_LIST_ERROR,
  payload: error
});

export const AcquisitionDetailDetail = (data) => ({
  type: ACQUISITION_DETAIL_DETAIL,
  payload: data
});

export const AcquisitionDetailDetailSuccess = (data) => ({
  type: ACQUISITION_DETAIL_DETAIL_SUCCESS,
  payload: data
});

export const AcquisitionDetailDetailError = (error) => ({
  type: ACQUISITION_DETAIL_DETAIL_ERROR,
  payload: error
});

export const AcquisitionDetailSearchDemandList = () => ({
  type: ACQUISITION_DETAIL_SEARCH_DEMAND_LIST
});

export const AcquisitionDetailSearchDemandListSuccess = (message) => ({
  type: ACQUISITION_DETAIL_SEARCH_DEMAND_LIST_SUCCESS,
  payload: message
});

export const AcquisitionDetailSearchDemandListError = (error) => ({
  type: ACQUISITION_DETAIL_SEARCH_DEMAND_LIST_ERROR,
  payload: error
}); 
const acquisitionDetail = (state) => state[NAME];

export const AcquisitionDetailSelector = createStructuredSelector({
  acquisitionDetail
})
